import fetch from '@/utils/index'
// import axios from 'axios'   //导入axios
export function select (params) { // 获取组织结构接口
  // return this.$http.post('http://59.110.236.29:80/auth/zzSelect', params)
  return fetch({
    url: 'auth/zzSelect',
    method: 'post',
    data: params
  })
}
export function login (param1, param2, param3) { // 登陆接口
  // return this.$http.get('http://59.110.236.29:80/auth/login?rybm=' + param1 + '&rykl=' + param2 + '&xtid=' + param3)
  return fetch({
    url: 'auth/login?rybm=' + param1 + '&rykl=' + param2,
    method: 'get'
  })
}
export function menu (params) { // 获取菜单接口
  // return this.$http.post('http://59.110.236.29:80/sys/authority/portal', params)
  return fetch({
    url: 'https://imc-bj.com/sys/authority/portal',
    method: 'post',
    data: params
  })
}

// 供应商注册 初始化供应商标识
export function initPk () {
  return fetch({
    // url: 'http://127.0.0.1:8769/api-auth/auth/register/supplier/initPk',
    url: 'auth/register/supplier/initPk',
    method: 'post',
    data: null
  })
}

export function initPk2 () {
  return fetch({
    // url: 'http://127.0.0.1:8769/api-auth/auth/register/supplier/initPk',
    url: 'auth/register/team/initPk',
    method: 'post',
    data: null
  })
}

// 供应商注册信息提交
export function register (params) {
  return fetch({
    // url: 'http://127.0.0.1:8769/api-auth/auth/register/supplier/add',
    url: 'auth/register/supplier/add',
    method: 'post',
    data: params
  })
}

export function register2 (params) {
  return fetch({
    // url: 'http://127.0.0.1:8769/api-auth/auth/register/supplier/add',
    url: 'auth/register/team/add',
    method: 'post',
    data: params
  })
}

// 发送短信验证码
export function checkCode (params) {
  return fetch({
    // url: 'http://127.0.0.1:8769/api-auth/auth/register/supplier/sendCheckCode',
    url: 'auth/register/supplier/sendCheckCode',
    method: 'post',
    data: params
  })
}

// 发送短信验证码
export function checkCode2 (params) {
  return fetch({
    // url: 'http://127.0.0.1:8769/api-auth/auth/register/supplier/sendCheckCode',
    url: 'auth/register/team/sendCheckCode',
    method: 'post',
    data: params
  })
}

// 附件上传
export function annxUpload (url, params) {
  return fetch({
    url: url,
    method: 'post',
    timeout: 20000,
    data: params
  })
}

// 附件删除
export function annxRemove (params) {
  return fetch({
    // url: 'http://127.0.0.1:8769/api-auth/auth/register/supplier/annex/remove',
    url: 'auth/register/supplier/annex/remove',
    method: 'post',
    data: params
  })
}

// 附件删除
export function annxRemove2 (params) {
  return fetch({
    // url: 'http://127.0.0.1:8769/api-auth/auth/register/supplier/annex/remove',
    url: 'auth/register/team/annex/remove',
    method: 'post',
    data: params
  })
}

// 推荐人
export function recommander (params) {
  return fetch({
    // url: 'http://127.0.0.1:8769/api-auth/auth/register/supplier/option/recommander',
    url: 'auth/register/supplier/option/recommander',
    method: 'post',
    data: params
  })
}

export function recommander2 (params) {
  return fetch({
    // url: 'http://127.0.0.1:8769/api-auth/auth/register/supplier/option/recommander',
    url: 'auth/register/team/option/recommander',
    method: 'post',
    data: params
  })
}

// 品类
export function category () {
  return fetch({
    // url: 'http://127.0.0.1:8769/api-auth/auth/register/supplier/option/tag',
    url: 'auth/register/supplier/option/tag',
    method: 'post',
    data: null
  })
}



// WEBPACK FOOTER //
// ./src/api/api.js